import React, { FC, useContext } from 'react';
import { ListContext } from './context';
import { Icon } from '../Icon';
import { IComponentChildrenProps } from '@src/models/props';
import { classnames } from '@src/utils/classnames';
import styled from './list.scss';

interface IProps extends IComponentChildrenProps {}

export const ListItem: FC<IProps> = ({ children }) => {
  const { mark, itemClassName, markColor, markSize = 'sm' } = useContext(ListContext);
  const classes = classnames(styled.item, itemClassName);

  return (
    <li className={classes}>
      {mark && <Icon name={mark} size={markSize} view={markColor} />}
      {children}
    </li>
  );
};
